import { checkScrollPoints } from "./check-scroll-points";

export function initStickyHeader() {
    function fn1() {
        //if(window.pageYOffset <= 0){
            //$header.removeClass("reverse-colors");
        //}
    }

    function fn2() {
        $header.addClass("reverse-color-new");
    }

    const $header = $("body:not('.sticky-header') .header");
    const $window = $(window);
    const $checkColorSection = $(".js-color-change");
    const exceptionEl = $(".form-section") || false;
    
    if ( $header.length ) {
        
        let $lastScrollPosition = 0;
    
        //if ($checkColorSection.length <= 0) {
            //$header.addClass("reverse-colors");
        //}
    
        $window.on("load", function () {
            checkScrollPoints($checkColorSection, $(this).scrollTop(), $(".header .wrap").height() / 2, fn1, fn2, exceptionEl);

            //if(window.pageYOffset > 0){
                //$header.addClass("reverse-colors");
            //}
        });
    
        $window.on("scroll", function () {
            let $currentScrollPosition = $(this).scrollTop();

            if ($currentScrollPosition > $lastScrollPosition && $currentScrollPosition >= 0) {

                //if ($currentScrollPosition > 0 && !($header.hasClass("show-searchbar") || $header.hasClass("revert-colors"))) {
                    //$header.addClass("sticky reverse-colors");
                //}

            } else {
                $header.removeClass("sticky");
            }

            if($currentScrollPosition < 0) {
                $("body, html").scrollTop(0);
                $currentScrollPosition = 0;
            }

            $lastScrollPosition = $currentScrollPosition;
        
            checkScrollPoints($checkColorSection, $currentScrollPosition, $(".header .wrap").height() / 2, fn1, fn2, exceptionEl);
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/modules/sticky-header.js